<script lang="ts">
    import { mdiChevronRight } from "@mdi/js"
    import Icon from "../../../widgets/Icon.svelte"
    import { spaLink } from "../../../../functionTools/navigation"

    let {
        subNavEl,
        showMobileSubnav = $bindable(false),
        closeMenu,
    }: { subNavEl: NavigationNode; showMobileSubnav: boolean; closeMenu: () => void } = $props()
</script>

{#if subNavEl.nodes && subNavEl.nodes.length}
    <button
        class="parent-nav button transparent"
        onclick={() => {
            showMobileSubnav = !showMobileSubnav
        }}
    >
        <div>
            <span>
                {subNavEl.name}
            </span>
        </div>
        <span class="navtrigger">
            <Icon path={mdiChevronRight} size="22px" />
        </span>
    </button>
{:else if subNavEl.external}
    <a
        class="parent-nav"
        href={subNavEl.externalUrl}
        target={subNavEl.target || "_self"}
        rel={subNavEl.target === "_blank" ? "noopener noreferrer" : undefined}
        onclick={(e) => {
            closeMenu()
        }}
    >
        <div>
            <span>
                {subNavEl.name}
            </span>
        </div>
    </a>
{:else}
    <a
        class="parent-nav"
        href={subNavEl.path}
        use:spaLink
        onclick={(e) => {
            closeMenu()
            e.preventDefault()
        }}
    >
        <div>
            <span>
                {subNavEl.name}
            </span>
        </div>
    </a>
{/if}

<style lang="less">
    .parent-nav,
    a {
        div {
            position: relative;
            display: flex;
            align-items: center;
        }
    }
</style>
